export default __webpack_public_path__ + "static/media/fake4.88ecaee7.jpg";